import React from 'react';
import { copyFor } from 'config';
import { Crate, FlexCrate, Icon, Tooltip } from '@perch-labs/shrike';
import {
  StyledListItem,
  StyledContainer,
  StyledHeading,
  StyledSupportingText,
  StyledTooltipContainer,
} from '../line-items.style';
import { LineItemAmount } from '../line-item-amount.component';

interface Props {
  lineItem: UtilityLineItem;
  includeTooltips: boolean;
  includeSupportingText: boolean;
  utilityName?: string;
}

const getCopy = copyFor(
  'billing.statement.lineItems.localUtilityChargeWithVnmSolar'
);

export const LocalUtilityChargeWithVnmSolarLineItem = ({
  lineItem,
  includeTooltips,
  includeSupportingText,
  utilityName,
}: Props) => {
  const tooltipCopy = getCopy('tooltip.copy', {
    utilityName,
  });

  return (
    <StyledListItem data-testid="local-utility-charge-with-vnm-solar-line-item">
      <StyledContainer>
        <FlexCrate flexDirection="column" gap="8px">
          <StyledTooltipContainer>
            <StyledHeading>{getCopy('title')}</StyledHeading>
            {includeTooltips && (
              <Tooltip
                content={tooltipCopy}
                tooltipId="localUtilityCharge"
                label={getCopy('tooltip.label')}
              >
                <Icon icon="InfoCircleInverted" />
              </Tooltip>
            )}
          </StyledTooltipContainer>
          {includeSupportingText && (
            <Crate padding="0 64px 0 0">
              <StyledSupportingText>{tooltipCopy}</StyledSupportingText>
            </Crate>
          )}
        </FlexCrate>
        <LineItemAmount amountCents={lineItem.amountCents} />
      </StyledContainer>
    </StyledListItem>
  );
};
